module.exports = __webpack_public_path__ + "media/images/soar/bgAuthIcon-0a4692d1a3ef81ee26a7d6de680b79a6.png";